import { createSlice } from "@reduxjs/toolkit";
import { toGetNews } from "../actions/news.actions";

const initialState = {
  news: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const newsSlice = createSlice({
  name: "news",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetNews.pending, (state) => {
      state.news = { list: [], status: "idle" };
    });
    builder.addCase(toGetNews.fulfilled, (state, action) => {
      state.news = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetNews.rejected, (state, action) => {
      state.news = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default newsSlice.reducer;
